import { createIntl, createIntlCache, type IntlShape } from 'react-intl';

const cache = createIntlCache();

let intl: IntlShape;

export const updateIntl = () => {
  intl = createIntl(
    {
      locale: 'en',
    },
    cache,
  );

  return intl;
};

export const getIntl = () => intl;
